import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'CAMP_UPDATE',
    smsDelete : 'CAMP_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        camp: [],

        submitSuccess: false,
        campLoading: false,
        campError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_CAMP(state, camp) {
            state.camp = camp;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        CAMP_LOADING (state, loading) {
            state.campLoading = loading;
        },

        CAMP_ERROR (state, hasError) {
            state.campError = hasError;
        }
    },

    actions: {
        async addCamp ({commit, dispatch}, payload) {
            commit('CAMP_LOADING', true);
            commit('CAMP_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_camp, payload.camp, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCamp')
                return response

            } catch (e) {
                commit('CAMP_ERROR', true);
            } finally {
                commit('CAMP_LOADING', false);
            }
        },

        async fetchCamp ({ commit }) {
            commit('CAMP_LOADING', true);
            commit('CAMP_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.camp_list, config);
                let response = result.data
                commit('SET_CAMP', response.data);

            } catch(error) {
                commit('CAMP_ERROR', true);
            } finally {
                commit('CAMP_LOADING', false);
            }
        },

        async getCampsByArea ({ commit }, payload) {
            commit('CAMP_LOADING', true);
            commit('CAMP_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.camp_list_by_area + payload, config);
                let response = result.data
                commit('SET_CAMP', response.data);

            } catch(error) {
                commit('CAMP_ERROR', true);
            } finally {
                commit('CAMP_LOADING', false);
            }
        },

        async updateCamp ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_camp + payload.id, payload.camp, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCamp')
                return response

            } catch (e) {
                commit('CAMP_ERROR', true);
            } finally {
                commit('CAMP_LOADING', false);
            }
        },
        
        async deleteCamp({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.camp_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCamp')
            return response
        }
    },

    getters: {}
}
